import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "scroll-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_card_title, {
      class: "title px-8 interstate",
      color: "primary"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.title.toUpperCase()), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ion_row, {
        class: "expand-row",
        style: {"padding-bottom":"20px"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderHistory, (order, index) => {
            return (_openBlock(), _createBlock(_component_ion_col, {
              "size-xs": "8",
              "size-sm": "6",
              "size-md": "4",
              class: "order-card-col",
              key: index
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card, {
                  style: {"margin-inline":"5px","padding-bottom":"20px"},
                  mode: "ios"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_content, { class: "ion-text-center" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.items.slice(0, 3), (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "pb-4"
                          }, [
                            _createVNode(_component_ion_text, {
                              class: "interstate-bold ion-text-center",
                              style: {"font-size":"1.1em"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.nameDisplay), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                            _createVNode(_component_ion_text, {
                              class: "ion-text-center",
                              style: {"font-size":"0.9em"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.description), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_row, {
                      class: "d-flex",
                      style: {"flex-direction":"column","align-content":"center","align-items":"center"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          shape: "round",
                          style: {"font-weight":"bold","--box-shadow":"0px 5px 5px gray"},
                          onClick: ($event: any) => (_ctx.repeatOrder(order))
                        }, {
                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createTextVNode(" Add to cart ")
                          ])),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ])
  ], 64))
}